import {
  TextInput,
  TextInputProps,
} from "@/flokit/compound/inputs/text-input/text-input";

export const DateQuestionEdit = (props: TextInputProps) => {
  return <TextInput {...props} type="date" value={props.value} />;
};
